// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Authenticate_wrapper__1-gaQ","content":"Authenticate_content__rF-g9"};